/**
 * Generic UI-injection slots exposed by the pathway WorkHub manager (`Manager_Pathway`).
 * The host (pathway) owns these extension-point keys and renders the slots; other packages
 * register components into them via `ModuleFE_Utils.registerRenderer` — pathway never imports
 * the feature packages that fill them.
 */
export const RendererKey_PathwayImportSave = 'pathway-import-save';
export const RendererKey_PathwayImportErrors = 'pathway-import-errors';
export const RendererKey_PathwayHtml = 'pathway-html';
export const RendererKey_PathwayReview = 'pathway-review';
//# sourceMappingURL=renderer-keys.js.map